"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = __importDefault(require("./styles"));
const Spacer = ({ size }) => {
    const classes = styles_1.default({ size });
    return react_1.default.createElement("div", { className: classes.spacer });
};
exports.default = Spacer;
